// First-run onboarding state. Two independent localStorage keys so that
// "skipped" never blocks the replay path: only `complete` suppresses the
// auto-open behavior; `skipped` is informational so we know the user
// dismissed at least once.
const COMPLETE_KEY = "roava:onboarding:v1:complete";
const SKIPPED_KEY = "roava:onboarding:v1:skipped";

const safeGet = (k: string): string | null => {
  try { return localStorage.getItem(k); } catch { return null; }
};
const safeSet = (k: string, v: string) => {
  try { localStorage.setItem(k, v); } catch { /* noop */ }
};
const safeRemove = (k: string) => {
  try { localStorage.removeItem(k); } catch { /* noop */ }
};

export function isOnboardingComplete(): boolean {
  return safeGet(COMPLETE_KEY) === "true";
}

export function isOnboardingSkipped(): boolean {
  return safeGet(SKIPPED_KEY) === "true";
}

/** Auto-open on first launch when neither completed nor skipped. */
export function shouldAutoOpenOnboarding(): boolean {
  return !isOnboardingComplete() && !isOnboardingSkipped();
}

export function markOnboardingComplete(): void {
  safeSet(COMPLETE_KEY, "true");
  safeRemove(SKIPPED_KEY);
}

export function markOnboardingSkipped(): void {
  safeSet(SKIPPED_KEY, "true");
}

/** For the Settings "Replay" entry — wipe both keys and re-arm auto-open. */
export function resetOnboarding(): void {
  safeRemove(COMPLETE_KEY);
  safeRemove(SKIPPED_KEY);
}

/** Cross-component trigger used by the Settings "Replay" button. */
export const ONBOARDING_OPEN_EVENT = "roava:onboarding:open";

export function requestOpenOnboarding(): void {
  try { window.dispatchEvent(new CustomEvent(ONBOARDING_OPEN_EVENT)); } catch { /* noop */ }
}
